module.exports = __webpack_public_path__ + "static/media/footer_3.d9fb83f5.webp";